<template>
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.873 8.75L8.56925 14.4462L7.5 15.5L0 8L7.5 0.5L8.56925 1.55375L2.873 7.25H15V8.75H2.873Z"
      fill="white"
    />
  </svg>
</template>
